var _mask, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 345,
    viewBox: "0 0 362 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 334,
    height: 345
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.063 150.979C328.63 122.12 318.093 94.5944 301.418 70.9207C300.323 69.3689 299.205 67.8369 298.063 66.3246C267.576 25.9517 220.1 0 166.772 0C74.7738 0 0.194412 77.2308 0.194412 172.5C0.184331 186.632 1.84988 200.714 5.15542 214.445C7.42084 227.636 19.4148 256.949 28.571 268.799L28.6178 268.908C58.549 314.819 109.257 345 166.772 345C258.769 345 333.348 267.769 333.348 172.5C333.348 165.307 332.92 158.12 332.063 150.979Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.063 150.979C328.63 122.12 318.093 94.5944 301.418 70.9207C300.323 69.3689 299.205 67.8369 298.063 66.3246C267.576 25.9517 220.1 0 166.772 0C74.7738 0 0.194412 77.2308 0.194412 172.5C0.184331 186.632 1.84988 200.714 5.15542 214.445C7.42084 227.636 19.4148 256.949 28.571 268.799L28.6178 268.908C58.549 314.819 109.257 345 166.772 345C258.769 345 333.348 267.769 333.348 172.5C333.348 165.307 332.92 158.12 332.063 150.979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-10.2739 299.584C-22.5754 287.283 -22.5754 267.338 -10.2739 255.037L101.299 144.715C147.557 194.917 169.443 218.762 166.957 216.25C160.795 210.023 152.243 206.165 142.789 206.165C135.039 206.165 129.814 207.292 122.177 213.123C117.085 217.01 87.7842 245.83 34.2739 299.584C21.9724 311.886 2.02765 311.886 -10.2739 299.584Z",
    fill: "#3E3E3E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362 134.304C362 134.304 329.711 166.514 265.132 230.935L221.96 188.525L354.289 56.0238C355.85 54.4607 358.383 54.459 359.946 56.0201C360.685 56.7582 361.106 57.756 361.119 58.8004C361.706 105.837 362 131.005 362 134.304Z",
    fill: "#39A2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.419 125.501L163.648 125.733L163.652 125.73C195.578 157.872 217.995 180.441 230.903 193.438L243.087 205.704C245.22 207.801 253.874 215.753 265.391 215.882C277.158 216.014 283.713 212.521 289.84 206.55L266.559 229.61L244.492 251.177C232.121 263.549 212.139 263.672 199.615 251.548L126.028 175.551C124.233 173.697 122.916 172.338 122.079 171.473C120.188 169.597 111.41 161.3 99.643 161.168C87.8764 161.036 81.3209 164.529 75.1944 170.5L98.4747 147.439L118.542 125.873C130.913 113.501 150.895 113.377 163.419 125.501Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.f7f1034e9e2c98345186eab24b956b91.svg";
export { ForwardRef as ReactComponent };